import { React, Component, Icon } from 'utils';
import moment from 'moment/src/moment';

export default class Campaign extends Component {

	handleClick = (event) => {
		event.preventDefault();

		var { onSelect, model } = this.props;
		if(onSelect) {
			onSelect(model);
		}
	}

	render() {
		var { model } = this.props;
		var itemType = 'fa fa-file';

		if(model.type === 'db') {
			itemType = 'fa fa-folder-o';
		}

		return <a href="#" onClick={this.handleClick}>
			<div className="icon-panel">
				<i className={itemType}></i>
				<div className="icon-body">
					<div className="published">{moment(model.published).format('DD.MM.YYYY')}</div>
					<h5>{model.title}</h5>
				</div>
			</div>
		</a>;
	}
}


// WEBPACK FOOTER //
// ./src/modules/app/resumes/campaign.js